// Copyright © 2021 Move Closer
export var Source;
(function (Source) {
    Source["PAP"] = "PAP";
    Source["PAPnD24"] = "PAPnD24";
    Source["MSPO"] = "MSPO";
})(Source || (Source = {}));
